import { Card, Empty } from 'antd';
export default function ApiDesignPage() {
  return <Card style={{marginTop:16}} title="接口设计"><Empty description="请在AI全流程中完成接口设计" /></Card>;
}
